export default __webpack_public_path__ + "static/media/black-point-measure-icon.854c2934.svg";